export default __webpack_public_path__ + "static/media/08.278a9320.webp";